import { useParams } from 'react-router-dom';
import './UserTest.css';
import TestHead from '../media/imagen/TestHeadSoc.svg';
import Rocket from '../media/imagen/Rocket.svg';
import TextRocket from '../media/imagen/TextRocket.svg';
import RocketButton from '../media/imagen/RocketButton.svg';
import EndTestIMG from '../media/imagen/EndTest.svg';
import { useEffect, useState, useMemo } from 'react';
import PresButton from '../media/imagen/PredQuest.svg';
import NextButton from '../media/imagen/NextQuest.svg';
import { useRef } from 'react';

const getNumFields = (groupSize) => {
  if (groupSize >= 5 && groupSize <= 7) return 1;
  if (groupSize >= 8 && groupSize <= 11) return 2;
  if (groupSize >= 12 && groupSize <= 16) return 3;
  if (groupSize >= 17 && groupSize <= 21) return 4;
  if (groupSize >= 22 && groupSize <= 26) return 5;
  return 1;
};

const DropdownSelect = ({ colleagues, value, onChange, index, disabledColleagues, showValidation }) => {
  const availableColleagues = colleagues.filter(
    colleague => !disabledColleagues.includes(colleague.user_id)
  );

  const isEmpty = value === '';
  const shouldShowInvalid = showValidation && isEmpty;

  return (
    <div className="dropdown-container">
      <span>Коллега {index + 1}</span>
      <select
        value={value}
        onChange={(e) => onChange(index, e.target.value)}
        className={`dropdown-select ${shouldShowInvalid ? 'invalid' : ''}`}
      >
        <option value="">Выберите коллегу</option>
        {availableColleagues.map(colleague => (
          <option key={colleague.user_id} value={colleague.user_id}>
            {colleague.user_name}
          </option>
        ))}
      </select>
      {shouldShowInvalid && (
        <div className="dropdown-error">Обязательное поле</div>
      )}
    </div>
  );
};

const SociometryQuestion = ({ 
  colleagues, 
  currentUserId, 
  questionId, 
  variant,
  onAnswerChange,
  initialAnswer = [],
  showValidation,
  sociometryType // Добавлен новый проп
}) => {
  const isNonParametric = sociometryType === 'non-parametric';
  
  // Для непараметрического теста всегда начинаем с одного поля
  const initialFieldCount = isNonParametric 
    ? Math.max(1, initialAnswer.length) 
    : getNumFields(colleagues.length);
  
  const [selectedValues, setSelectedValues] = useState(
    initialAnswer.length === initialFieldCount ? initialAnswer : Array(initialFieldCount).fill('')
  );
  
  useEffect(() => {
    setSelectedValues(
      initialAnswer.length === initialFieldCount ? initialAnswer : Array(initialFieldCount).fill('')
    );
  }, [questionId, initialAnswer, initialFieldCount]);

  const handleSelectChange = (index, value) => {
    const newValues = [...selectedValues];
    newValues[index] = value;
    setSelectedValues(newValues);
    onAnswerChange(questionId, variant, newValues);
  };
  
  // Добавление нового поля
  const handleAddField = () => {
    if (selectedValues.length < colleagues.length - 1) {
      const newValues = [...selectedValues, ''];
      setSelectedValues(newValues);
      onAnswerChange(questionId, variant, newValues);
    }
  };
  
  // Удаление поля
  const handleRemoveField = (index) => {
    if (selectedValues.length > 1) {
      const newValues = [...selectedValues];
      newValues.splice(index, 1);
      setSelectedValues(newValues);
      onAnswerChange(questionId, variant, newValues);
    }
  };
  
  const disabledColleagues = [
    currentUserId, 
    ...selectedValues.filter(v => v && v !== '')
  ];

  // Проверка наличия хотя бы одного ответа для непараметрического теста
  const hasAtLeastOneAnswer = isNonParametric 
    ? selectedValues.some(val => val !== '')
    : true;

  return (
    <div className='SocioAnswerOne'>
      {selectedValues.map((value, index) => (
        <div key={index} className="dropdown-with-actions">
          <DropdownSelect
            colleagues={colleagues}
            value={value}
            index={index}
            onChange={handleSelectChange}
            disabledColleagues={disabledColleagues}
            showValidation={showValidation}
          />
          {isNonParametric && selectedValues.length > 1 && (
            <button 
              className="remove-field-btn"
              onClick={() => handleRemoveField(index)}
            >
              ×
            </button>
          )}
        </div>
      ))}
      {isNonParametric && selectedValues.length < colleagues.length - 1 && (
        <button className="add-field-btn" onClick={handleAddField}>
          +
        </button>
      )}
      
      {/* Общая ошибка для непараметрического теста */}
      {isNonParametric && showValidation && !hasAtLeastOneAnswer && (
        <div className="dropdown-error" style={{ marginTop: '10px' }}>
          Пожалуйста, укажите хотя бы одного коллегу
        </div>
      )}
    </div>
  );
};

// LeadershipQuestion, LeadershipBlock, BelbenQuestion, BelbenBlock, 
// StartWindow, EndWindow, ProgressBar остаются без изменений

const LeadershipQuestion = ({ question, value, onChange }) => {
  const [dragging, setDragging] = useState(false);
  const sliderRef = useRef(null);
  const [localValue, setLocalValue] = useState(value || 0);

  const handleMouseDown = (e) => {
    setDragging(true);
    updateValue(e);
  };

  const handleMouseMove = (e) => {
    if (!dragging) return;
    updateValue(e);
  };

  const handleMouseUp = () => {
    setDragging(false);
    onChange(localValue);
  };

  const handleTouchStart = (e) => {
    setDragging(true);
    updateValue(e.touches[0]);
  };

  const handleTouchMove = (e) => {
    if (!dragging) return;
    updateValue(e.touches[0]);
  };

  const handleTouchEnd = () => {
    setDragging(false);
    onChange(localValue);
  };

  const updateValue = (e) => {
    if (!sliderRef.current) return;
    
    const rect = sliderRef.current.getBoundingClientRect();
    let x = e.clientX - rect.left;
    x = Math.max(0, Math.min(rect.width, x));
    
    const percent = x / rect.width;
    const rawValue = percent * 4;
    const snappedValue = Math.round(rawValue);
    
    setLocalValue(snappedValue);
  };

  useEffect(() => {
    setLocalValue(value || 0);
  }, [value]);

  useEffect(() => {
    onChange(localValue);
  }, [localValue, onChange]);

  useEffect(() => {
    if (dragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
      window.addEventListener('touchmove', handleTouchMove);
      window.addEventListener('touchend', handleTouchEnd);
    }
    
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
      window.removeEventListener('touchmove', handleTouchMove);
      window.removeEventListener('touchend', handleTouchEnd);
    };
  }, [dragging]);

  return (
    <div className="leadership-question">
      <span>{question.title}</span>
      <div 
        className="slider-container" 
        ref={sliderRef}
        onClick={updateValue}
      >
        <div className="slider-track">
          <div 
            className="slider-fill" 
            style={{ 
              width: `${localValue * 25}%`,
              background: `linear-gradient(to right, #C5DCFF, #1A62CE)`
            }} 
          />
          <div 
            className="slider-thumb" 
            style={{ left: `${localValue * 25}%` }} 
            onMouseDown={handleMouseDown}
            onTouchStart={handleTouchStart}
          />
        </div>
        <div className="ticks-container">
          {[0, 1, 2, 3, 4].map((tick) => (
            <div key={tick} className="tick">
              <div className="tick-mark" />
              <div className="tick-label">{tick}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const BelbenQuestion = ({ question, value, onChange, maxValue }) => {
  const [dragging, setDragging] = useState(false);
  const sliderRef = useRef(null);
  const [localValue, setLocalValue] = useState(value || 0);

  const handleMouseDown = (e) => {
    setDragging(true);
    updateValue(e);
  };

  const handleMouseMove = (e) => {
    if (!dragging) return;
    updateValue(e);
  };

  const handleMouseUp = () => {
    setDragging(false);
    onChange(localValue);
  };

  const handleTouchStart = (e) => {
    setDragging(true);
    updateValue(e.touches[0]);
  };

  const handleTouchMove = (e) => {
    if (!dragging) return;
    updateValue(e.touches[0]);
  };

  const handleTouchEnd = () => {
    setDragging(false);
    onChange(localValue);
  };

  const updateValue = (e) => {
    if (!sliderRef.current) return;
    
    const rect = sliderRef.current.getBoundingClientRect();
    let x = e.clientX - rect.left;
    x = Math.max(0, Math.min(rect.width, x));
    
    const percent = x / rect.width;
    const rawValue = percent * 10;
    let snappedValue = Math.round(rawValue);
    
    // Ограничение значения по maxValue
    snappedValue = Math.min(snappedValue, maxValue);
    
    setLocalValue(snappedValue);
  };

  useEffect(() => {
    setLocalValue(value || 0);
  }, [value]);

  useEffect(() => {
    onChange(localValue);
  }, [localValue, onChange]);

  useEffect(() => {
    if (dragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
      window.addEventListener('touchmove', handleTouchMove);
      window.addEventListener('touchend', handleTouchEnd);
    }
    
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
      window.removeEventListener('touchmove', handleTouchMove);
      window.removeEventListener('touchend', handleTouchEnd);
    };
  }, [dragging]);

  return (
    <div className="leadership-question">
      <span>{question.body}</span>
      <div 
        className="slider-container" 
        ref={sliderRef}
        onClick={updateValue}
      >
        <div className="slider-track">
          <div 
            className="slider-fill" 
            style={{ 
              width: `${localValue * 10}%`,
              background: `linear-gradient(to right, #C5DCFF, #1A62CE)`
            }} 
          />
          <div 
            className="slider-thumb" 
            style={{ left: `${localValue * 10}%` }} 
            onMouseDown={handleMouseDown}
            onTouchStart={handleTouchStart}
          />
        </div>
        <div className="ticks-container">
          {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((tick) => (
            <div key={tick} className="tick">
              <div className="tick-mark" />
              <div className="tick-label">{tick}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const LeadershipBlock = ({ block, answers, onAnswerChange }) => {
  const initializedAnswers = useMemo(() => {
    return block.questions.map((_, idx) => answers[idx] || 0);
  }, [answers, block.questions]);

  return (
    <>
      <h1 className='BlockH'>Блок {block.blockIndex + 1}</h1>
      <div className='LiderQuest'> 
        <div className='LiderQuestHelp'>
          <p>
            0 - Полностью не согласен<br />
            1 - Скорее не согласен, чем согласен<br />
            2 - Трудно сказать<br />
            3 - Скорее согласен, чем не согласен<br />
            4 - Полностью согласен
          </p>
        </div>
      
        <div className="leadership-block">
          {block.questions.map((question, idx) => (
            <LeadershipQuestion
              key={question.id}
              question={question}
              value={initializedAnswers[idx]}
              onChange={(value) => onAnswerChange(idx, value)}
            />
          ))}
        </div>
      </div>
    </>
  );
};

const BelbenBlock = ({ block, answers, onAnswerChange }) => {
  // Вычисляем общую сумму баллов в блоке
  const total = (answers || []).reduce((sum, val) => sum + (val || 0), 0);
  
  // Вычисляем доступные баллы для каждого вопроса
  const maxValues = (answers || []).map((val, idx) => {
    const currentValue = val || 0;
    // Доступное значение = текущее значение + оставшиеся баллы
    return currentValue + (10 - total);
  });

  return (
    <>
      <h1 className='BlockH'>{block.data.title}</h1>
      <div className='LiderQuest'> 
        <div className='LiderQuestHelp'>
          <p>
            Распределите 10 баллов в каждом блоке утверждений. Отдавайте больше баллов тем утверждениям, которые, по вашему мнению, лучше всего описывают ваше поведение. Баллы необходимо распределить по нескольким утверждениям или все десять баллов поставить напротив одного утверждения.
          </p>
        </div>
      
        <div className="leadership-block" style={{ marginBottom: '20px' }}>
          {block.data.data.questions.map((question, idx) => (
            <BelbenQuestion
              key={`${question.body}-${idx}`}
              question={question}
              value={answers[idx] || 0}
              maxValue={maxValues[idx]} // Передаём максимальное значение
              onChange={(value) => onAnswerChange(idx, value)}
            />
          ))}
        </div>
      </div>
    </>
  );
};

const StartWindow = ({ onStart }) => {
  return (
    <div className='TestBody'> 
      <img src={Rocket} alt="Ракета на взлете" />
      <img src={TextRocket} alt="Текст стартового окна" />
      <img 
        src={RocketButton} 
        alt="Начать тестирование" 
        onClick={onStart}
        style={{ cursor: 'pointer' }}
      />
    </div>
  );
};

const EndWindow = () => {
  return (
    <div className='TestBody'> 
      <img src={EndTestIMG} alt="Тест завершен" />
    </div>
  );
};

const ProgressBar = ({ current, total }) => {
  const percentage = (current / total) * 100;
  
  return (
    <div className='ProgressBar'>
      <div className="progress-counter">
        {current}/{total}
      </div>
      <div className="progress-track">
        <div 
          className="progress-fill" 
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};

const UserTest = () => {
  const [testData, setTestData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stage, setStage] = useState('start');
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [showValidation, setShowValidation] = useState(false);
  const [hasUnansweredQuestions, setHasUnansweredQuestions] = useState(false);

  const { testId, userId } = useParams();
  const currentUserId = parseInt(userId, 10);

  // Определение типа социометрии
  const sociometryType = useMemo(() => {
    if (!testData?.description) return 'parametric';
    const desc = testData.description.toLowerCase();
    return desc.includes('непараметрическое') ? 'non-parametric' : 'parametric';
  }, [testData]);

  const normalizeTestData = (data) => {
    if (!data || !data.questions) return data;
    
    // Нормализуем вопросы
    const normalizedQuestions = data.questions.map(question => ({
      ...question,
      // Унифицируем поле типа
      quest_type: question.quest_type || question.question_type,
      // Унифицируем поле идентификатора
      id: question.id || question.quest_id
    }));
    
    return {
      ...data,
      questions: normalizedQuestions
    };
  };

  useEffect(() => {
    const fetchTestData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('authToken');
        if (!token) throw new Error('Токен авторизации не найден');

        const response = await fetch(`http://185.250.149.189:8000/api/v1/Test?id=${testId}`, {
          headers: { 'Authorization': `Token ${token}` }
        });

        if (!response.ok) throw new Error(`Ошибка HTTP: ${response.status}`);
        
        const data = await response.json();
        if (!data.tests || data.tests.length === 0) {
          throw new Error('Тест не найден');
        }
        
        setTestData(normalizeTestData(data.tests[0]));
      } catch (error) {
        console.error('Ошибка загрузки данных теста:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTestData();
  }, [testId]);

    useEffect(() => {
        console.log(testData)
    }, [testData]);  

  const groupQuestionsByType = (questions) => {
    const grouped = {
      sociometry: [],
      leadership: [],
      belben: []
    };
    
    questions.forEach(q => {
      if (q.quest_type === 'sociometry') {
        grouped.sociometry.push(q);
      } else if (q.quest_type === 'leadership') {
        grouped.leadership.push(q);
      } else if (q.quest_type === 'belben') {
        grouped.belben.push(q);
      }
    });
    
    return grouped;
  };

  const transformQuestions = (questions) => {
    const grouped = groupQuestionsByType(questions);
    const screens = [];
    
    // Обработка социометрических вопросов
    grouped.sociometry.forEach(q => {
      screens.push({
        type: 'sociometry',
        data: {
          ...q,
          variant: 'positive',
          title: q.title.replace('...', q.data.good_tail)
        }
      });
      screens.push({
        type: 'sociometry',
        data: {
          ...q,
          variant: 'negative',
          title: q.title.replace('...', q.data.bad_tail)
        }
      });
    });
    
    // Обработка лидерских вопросов
    const leadershipBlocks = [];
    for (let i = 0; i < grouped.leadership.length; i += 3) {
      leadershipBlocks.push({
        type: 'leadership_block',
        blockIndex: leadershipBlocks.length,
        questions: grouped.leadership.slice(i, i + 3)
      });
    }
    screens.push(...leadershipBlocks);
    
    // Обработка вопросов Белбена
    grouped.belben.forEach(q => {
      screens.push({
        type: 'belben_block',
        data: q
      });
    });
    
    return screens;
  };

  const transformedScreens = useMemo(() => {
    return testData?.questions ? transformQuestions(testData.questions) : [];
  }, [testData]);

  const totalScreens = transformedScreens.length;
  const currentScreen = transformedScreens[currentQuestionIndex];

  const colleagues = useMemo(() => {
    if (!testData?.group?.users) return [];
    return testData.group.users.filter(user => user.user_id !== currentUserId);
  }, [testData, currentUserId]);

  const handleAnswerChange = (questionId, variant, answer) => {
    setAnswers(prev => ({
      ...prev,
      [currentQuestionIndex]: {
        type: 'sociometry',
        questionId,
        variant,
        answer
      }
    }));
  };

  const handleLeadershipAnswer = (questionIndex, value) => {
    setAnswers(prev => {
      const screenAnswers = prev[currentQuestionIndex]?.answers || Array(3).fill(0);
      const newAnswers = [...screenAnswers];
      newAnswers[questionIndex] = value;
      
      return {
        ...prev,
        [currentQuestionIndex]: {
          type: 'leadership_block',
          answers: newAnswers
        }
      };
    });
  };

  const handleBelbenAnswer = (questionIndex, value) => {
    setAnswers(prev => {
      const numQuestions = currentScreen.data.data.questions.length;
      const screenAnswers = prev[currentQuestionIndex]?.answers || Array(numQuestions).fill(0);
      const newAnswers = [...screenAnswers];
      newAnswers[questionIndex] = value;
      
      return {
        ...prev,
        [currentQuestionIndex]: {
          type: 'belben_block',
          answers: newAnswers
        }
      };
    });
  };

  const isAllFieldsFilled = useMemo(() => {
    if (!currentScreen) return true;
    
    if (currentScreen.type === 'sociometry') {
      // Для параметрического теста - все поля должны быть заполнены
      if (sociometryType === 'parametric') {
        const numFields = getNumFields(colleagues.length);
        const currentAnswer = answers[currentQuestionIndex];
        return currentAnswer?.answer?.length === numFields && 
               currentAnswer.answer.every(val => val !== '');
      } 
      // Для непараметрического - хотя бы одно поле должно быть заполнено
      else {
        const currentAnswer = answers[currentQuestionIndex];
        return currentAnswer?.answer?.some(val => val !== '');
      }
    }
    
    return true;
  }, [answers, currentQuestionIndex, currentScreen, colleagues.length, sociometryType]);

  const checkAllQuestionsAnswered = () => {
    for (let i = 0; i < totalScreens; i++) {
      const screen = transformedScreens[i];
      
      if (!answers[i]) {
        return false;
      }
      
      if (screen.type === 'sociometry') {
        // Для параметрического теста - проверяем все поля
        if (sociometryType === 'parametric') {
          const numFields = getNumFields(colleagues.length);
          if (!answers[i].answer || answers[i].answer.length !== numFields || 
              answers[i].answer.some(val => val === '')) {
            return false;
          }
        } 
        // Для непараметрического - проверяем хотя бы одно поле
        else {
          if (!answers[i].answer || !answers[i].answer.some(val => val !== '')) {
            return false;
          }
        }
      }
    }
    return true;
  };

  const handleStartTest = () => {
    setStage('questions');
  };

  const handleNextQuestion = () => {
    if (currentScreen?.type === 'sociometry' && !isAllFieldsFilled) {
      setShowValidation(true);
      setTimeout(() => setShowValidation(false), 2000);
      return;
    }

    if (currentQuestionIndex < totalScreens - 1) {
      setCurrentQuestionIndex(prev => prev + 1);
      setShowValidation(false);
    } else {
      if (!checkAllQuestionsAnswered()) {
        setHasUnansweredQuestions(true);
        setTimeout(() => setHasUnansweredQuestions(false), 3000);
        return;
      }
      
      const finalAnswers = [];
      const sociometryMap = {};
      
      // Собираем социометрические ответы
      Object.entries(answers).forEach(([screenIndex, answerData]) => {
        const screen = transformedScreens[parseInt(screenIndex)];
        
        if (screen.type === 'sociometry' && answerData.type === 'sociometry') {
          const questionId = answerData.questionId;
          const numericAnswer = answerData.answer.map(id => parseInt(id, 10));
          
          if (!sociometryMap[questionId]) {
            sociometryMap[questionId] = {
              quest_id: questionId,
              quest_type: 'sociometry',
              good_answers: [],
              bad_answers: []
            };
          }
          
          if (answerData.variant === 'positive') {
            sociometryMap[questionId].good_answers = numericAnswer;
          } else if (answerData.variant === 'negative') {
            sociometryMap[questionId].bad_answers = numericAnswer;
          }
        } 
      });
      
      // Добавляем объединенные социометрические ответы
      Object.values(sociometryMap).forEach(answer => {
        finalAnswers.push(answer);
      });
      
      // Обрабатываем остальные типы вопросов
      Object.entries(answers).forEach(([screenIndex, answerData]) => {
        const screen = transformedScreens[parseInt(screenIndex)];
        
        if (screen.type === 'leadership_block' && answerData.type === 'leadership_block') {
          screen.questions.forEach((question, idx) => {
            finalAnswers.push({
              quest_id: question.id,
              quest_type: 'leadership',
              data: question.data,
              answer: answerData.answers[idx] || 0
            });
          });
        }
        else if (screen.type === 'belben_block' && answerData.type === 'belben_block') {
          const traits = {};
          
          screen.data.data.questions.forEach((question, idx) => {
            // Используем trait, если он есть, иначе используем title
            const traitKey = question.trait || question.title;
            traits[traitKey] = answerData.answers[idx] || 0;
          });
          
          finalAnswers.push({
            quest_id: screen.data.id,
            quest_type: 'belben',
            data: traits
          });
        }
      });
      
      // Формируем данные для отправки
      const submissionData = {
        test_id: parseInt(testId, 10),
        user_id: parseInt(userId, 10),
        answer: finalAnswers
      };
      
      // Выводим в консоль для отладки
      console.log('Отправляемые данные:', JSON.stringify(submissionData, null, 2));
      
      // Отправляем данные на сервер
      sendAnswersToServer(submissionData);
    }
  };

    const sendAnswersToServer = async (data) => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) throw new Error('Токен авторизации не найден');
      
      const response = await fetch('http://185.250.149.189:8000/api/v1/Answer/', {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Ошибка HTTP: ${response.status}`);
      }
      
      const responseData = await response.json();
      console.log('Ответ сервера:', responseData);
      
      // Переходим на экран завершения
      setStage('end');
    } catch (error) {
      console.error('Ошибка отправки ответов:', error);
      setError(`Ошибка отправки ответов: ${error.message}`);
    }
  };

  const handlePrevQuestion = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(prev => prev - 1);
      setShowValidation(false);
    }
  };

  if (loading) return <div className='UserRoad'>Загрузка...</div>;
  if (error) return <div className='UserRoad'>Ошибка: {error}</div>;

  return (
    <div className='UserRoad'>
      <div className='TestBox'> 
        <div className='TestHead'> 
          <img 
            src={TestHead} 
            alt="Шапка тестирования" 
          />
        </div>
        
        {stage === 'start' && <StartWindow onStart={handleStartTest} />}
        
        {stage === 'questions' && (
          <div className='TestBodyQuest'> 
            <ProgressBar 
              current={currentQuestionIndex + 1} 
              total={totalScreens} 
            />
            
            {currentScreen?.type === 'sociometry' && (
              <>
                <div className='SocioQuest'> 
                  <h1>Вопрос {currentQuestionIndex + 1}</h1>
                  <div className='SocioQuestHelp'>
                    <h2>{currentScreen.data.title}</h2>
                    <p>
                      Укажите первым того, кого бы Вы выбрали в первую очередь, 
                      вторым — того, кого выбрали бы во вторую очередь и так далее, 
                      если требуется
                    </p>
                  </div>
                </div>
                
                <SociometryQuestion
                  colleagues={colleagues}
                  currentUserId={currentUserId}
                  questionId={currentScreen.data.id}
                  variant={currentScreen.data.variant}
                  onAnswerChange={handleAnswerChange}
                  initialAnswer={
                    answers[currentQuestionIndex]?.answer || []
                  }
                  showValidation={showValidation}
                  sociometryType={sociometryType} // Передаем тип социометрии
                />
              </>
            )}
            
            {currentScreen?.type === 'leadership_block' && (
              <LeadershipBlock
                block={currentScreen}
                answers={answers[currentQuestionIndex]?.answers || []}
                onAnswerChange={(idx, value) => 
                  handleLeadershipAnswer(idx, value)
                }
              />
            )}

            {currentScreen?.type === 'belben_block' && (
              <BelbenBlock
                block={currentScreen}
                answers={answers[currentQuestionIndex]?.answers || []}
                onAnswerChange={(idx, value) => 
                  handleBelbenAnswer(idx, value)
                }
              />
            )}

            {showValidation && (
              <div className="validation-message">
                Пожалуйста, заполните все поля
              </div>
            )}
            
            {hasUnansweredQuestions && (
              <div className="validation-message" style={{ marginTop: '20px' }}>
                Пожалуйста, ответьте на все вопросы теста
              </div>
            )}
            
            <div className='NextPredBotton'> 
              <button 
                onClick={handlePrevQuestion}
                disabled={currentQuestionIndex === 0}
              >
                <img src={PresButton} alt="Предыдущий вопрос" />
              </button>
              <button 
                onClick={handleNextQuestion}
              >
                <img 
                  src={NextButton} 
                  alt={currentQuestionIndex === totalScreens - 1 ? "Завершить тест" : "Следующий вопрос"} 
                  style={{ 
                    opacity: (currentScreen?.type === 'sociometry' && !isAllFieldsFilled) ? 0.6 : 1 
                  }}
                />
              </button>
            </div>
          </div>
        )}
        
        {stage === 'end' && <EndWindow />}
      </div>    
    </div>
  );
};

export default UserTest;